import cookies from "js-cookie";
import { COOKIE_NAME } from "./constants";

const setCookieFromFeatureVariables = variables => {
  cookies.set(COOKIE_NAME, variables.queryParams, { expires: 7 });
};

export default setCookieFromFeatureVariables;
